import { Component, OnInit } from '@angular/core';
import { CertificationServiceServiceProxy, CCertificationDto, CertificationScore, CCertificationStatusEnum } from '@shared/service-proxies/service-proxies';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { LoadingController, AlertController, Platform, NavController } from '@ionic/angular';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { Title } from '@angular/platform-browser';
import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-certification-score',
  templateUrl: './certification-score.page.html',
  styleUrls: ['./certification-score.page.scss'],
})
export class CertificationScorePage implements OnInit {

  id: number = 0;
  certification: CCertificationDto;
  certificationScores: CertificationScore;
  isLoaded: boolean = false;
  outerStrokeColor: string;
  innerStrokeColor: string;
  showCategoryPoints: boolean = false;
  certificationPassingScore: number = 63;
  certificationPassingPoints: number = 126;
  certificationTotalPossiblePoints: number = 200;

  constructor(
    private certificationService: CertificationServiceServiceProxy,
    storageService: AppStorageService,
    private route: ActivatedRoute,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private router: Router,
    private permissionChecker: PermissionCheckerService,
    private titleService: Title,
    public platform: Platform,
    private navCtrl: NavController
  ) {
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.route.queryParams.subscribe(params => {
          if (params && params.certificationId) {
            this.id = +params.certificationId;
            if (this.id > 0) { // id is required
              this.getCertification();
            }
          }
          this.isLoaded = true;
        });
      }
    });
    this.titleService.setTitle('OACI - Certification Score');
  }

  ngOnInit() {
  }

  async getCertification() {
    
    const loading = await this.loadingController.create({
      message: 'Fetching certification score...',
    });
    await loading.present();

    this.certificationService.get(this.id).subscribe(async certification => {
      this.certification = certification;
      if (this.certification) {
        if (this.certification.statusId != CCertificationStatusEnum._2) {
          await loading.dismiss();

          const alert = await this.alertController.create({
            header: 'Error',
            message: 'This certification has not been completed. Redirecting to certification page.',
            buttons: [
              {
                text: 'Okay',
                handler: () => {
                  const navigationExtras: NavigationExtras = {
                    queryParams: {
                      certificationId: this.id
                    }
                  };
                  this.router.navigate(['/main/certification'], navigationExtras);
                }
              }
            ]
          });

          await alert.present();
          return;
        }
        this.certificationService.getCertificationScores(this.id).subscribe(async certificationScores => {
          await loading.dismiss();
          this.certificationScores = certificationScores;
        });
      }
      
      setTimeout(() => {
        this.showCategoryPoints = true; // this.permissionChecker.isGranted("Pages.Certifications");
      }, 100);
    });
  }

  getCertificationScoreMessage() {
    if (this.certificationScores) {
      if (this.isPassing()) {
        return 'Congratulations! You are now certified. You have passed with a score of ' +
          this.certificationScores.points + '/' + this.certificationScores.weightedPoints; // +
          // ' (' + Math.round(this.certificationScores.percentageScore) + '%)';
      } else {
        return 'Sorry. Your score of ' +
          this.certificationScores.points + '/' + this.certificationScores.weightedPoints +
          ' was not enough to pass and be certified.<br>Please see the information icon below for more details.';
          // ' (' + Math.round(this.certificationScores.percentageScore) + '%) was not enough to pass and be certified.<br>Please see the information icon below for more details.';
      }
    } else {
      return '';
    }
  }

  getScore() {
    if (this.certificationScores) {
      return this.certificationScores.percentageScore;
    } else {
      return 0;
    }
  }

  scoreBelowPassing() {
    if (this.certificationScores) {
      return this.certificationScores.percentageScore < this.certificationPassingScore;
    } else {
      return false;
    }
  }

  formatSubtitle = (percent: number) => {
    if (this.isPassing()) {
      this.outerStrokeColor = '#3880ff';
      this.innerStrokeColor = '#9bbfff';
      // return "Certified";
    } else {
      this.outerStrokeColor = '#f04141';
      this.innerStrokeColor = '#f7a0a0';
      // return "Non-Certified";
    }
    if (this.certificationScores) return '(' + this.certificationScores.points + '/' + this.certificationScores.weightedPoints + ')';
    else return '';
  }

  didLoad() {
    return this.id > 0 && this.certificationScores != null;
  }

  isPassing() {
    return this.certification && this.certification.isPassing;
  }

  async presentFailAlert(msg) {
    const alert = await this.alertController.create({
      header: '',
      message: this.certification && this.certification.completionMessage ? this.certification.completionMessage : 'Failed',
      buttons: ['OK']
    });

    await alert.present();
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      header: '',
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }

  goToHome() {
    this.navCtrl.back();
    // this.router.navigate(['/main/home']);
  }

  goToFarmerProfile() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        farmerId: this.certification.farmerId
      }
    };
    this.router.navigate(['/main/farmer'], navigationExtras);
  }

  print() {
    window.print();
  }

}
